// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1093":"67b437ed","1463":"9e4cda51","2731":"4b201a2c","3474":"67b437ed","5409":"4b201a2c","5662":"9e4cda51","6872":"d0cd9cc1","8078":"0cb86040"}[chunkId] + ".chunk.css";
};